const OrderRoutes = {
  getAllOrders: "/orders/all",
  quoteOrders: "/orders/quote",
  getOrderDetails: "/orders/orderbyid",
  orderStatus: "/status",
  completeOrder: "/orders/delivered",
  orderNotification: "orders/sendNotifications",
}

export default OrderRoutes